import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  async getDataSources(params) {
    try {
      const response = await axios.get('uni/qbQuestionSets', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  async createDataSource(params) {
    try {
      const response = await axios.post('uni/qbQuestionSets', params)
      const { data } = response
      const isSuccessful = data.code === ApiCode.SUCCESS
      if (isSuccessful) {
        return { isSuccessful, message: data.message }
      }
      return { isSuccessful, message: data.debugMessage }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async updateDataSource(params) {
    try {
      const response = await axios.put(`uni/qbQuestionSets/${params.id}`, params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async deleteDataSource(id) {
    try {
      const response = await axios.delete(`uni/qbQuestionSets/${id}`)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async getMaxOrderNo(params) {
    try {
      const response = await axios.get('uni/qbQuestionSets/max/order-no', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { maxOrderNo } = data.data
        return maxOrderNo
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
